import { registerPlugin } from '@capacitor/core';
import { ReferrerDetails } from '../interfaces/referrer-details';

interface ReferrerPlugin {
  getReferrerDetails(): Promise<ReferrerDetails>;
}

const Referrer = registerPlugin<ReferrerPlugin>('Referrer');
export { Referrer };
